import { render, staticRenderFns } from "./Ceo2024.vue?vue&type=template&id=2ec4d789&"
import script from "./Ceo2024.vue?vue&type=script&lang=js&"
export * from "./Ceo2024.vue?vue&type=script&lang=js&"
import style0 from "./Ceo2024.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports